import { SerializableObject } from '../../common-react/core';

import { DocumentType } from '../other/document-type.enum';

// DTO Object for representing Documents
export class Document extends SerializableObject {
  // Url to document
  public url: string;

  // Display friendly title of document
  public title: string;

  // The timestamp when the document was created
  public timestamp: Date;

  // Type of document
  public type: DocumentType;

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

    switch (propertyName) {
      case 'timestamp':
        if (typeof propertyValue === 'string') {
          return new Date(propertyValue);
        }
        return returnValue instanceof Date ? returnValue : undefined;

      default:
        return returnValue;
    }
  }
}
